// Estimated Firebase server time. lastSeen from onDisconnect is a server
// timestamp, so the 2-min host-handoff window must use the same clock — a
// skewed Date.now() would fire immediately or wait forever.
import { database } from '../firebase/firebaseConfig';
import { ref, onValue } from 'firebase/database';

let offsetMs = 0;
let started = false;

export function ensureServerClock() {
  if (started) return;
  started = true;
  try {
    onValue(ref(database, '.info/serverTimeOffset'), (snap) => {
      const v = snap.val();
      offsetMs = typeof v === 'number' && Number.isFinite(v) ? v : 0;
    });
  } catch {
    started = false;
  }
}

export function serverNow(localNow = Date.now()) {
  return localNow + offsetMs;
}

export function setServerTimeOffset(ms) {
  offsetMs = typeof ms === 'number' && Number.isFinite(ms) ? ms : 0;
}

export function resetServerClockForTests() {
  offsetMs = 0;
  started = false;
}
